import React from 'react';
import ratnaImage from '@/images/discovery/ratna.svg';
import Radio from '@mui/material/Radio';
import { useSelector } from 'react-redux';

import { paymentModeSelection } from '../../../../services/payment.service';
import LockIcon from '../../../Icons/icons/LockIcon';
import PoweredByStripe from '../../../Icons/icons/PoweredByStripe';
import ButtonComponent from '../../ButtonComponent/ButtonComponent';

import '../_modalComponent.scss';

interface Plan {
  _id: string;
  title: string;
  ratnas: number;
  price: number;
  planId: string;
}

interface OneTimeRatnaBoostSectionProps {
  plans: Plan[] | undefined;
  selectedPlan: string;
  setSelectedPlan: (planId: string) => void;
  setLeftSection: (section: string) => void;
}

const getColors = (plan: string) => {
  switch (plan) {
    case 'Kickstart':
      return {
        backgroundColor: '#FFF7ED',
        color: '#EA580C',
        border: '#EA580C',
      };
    case 'Boost':
      return {
        backgroundColor: '#F0FDF4',
        color: '#15803D',
        border: '#15803D',
      };
    case 'Favorite':
      return {
        backgroundColor: '#EFE6FC',
        color: '#7F38E9',
        border: '#7F38E9',
      };
    case 'Scale':
      return {
        backgroundColor: '#FEFCE8',
        color: '#CA8A04',
        border: '#CA8A04',
      };
    default:
      return {
        backgroundColor: '',
        color: '',
        border: '',
      };
  }
};

const OneTimeRatnaBoostSection: React.FC<OneTimeRatnaBoostSectionProps> = ({
  plans,
  selectedPlan,
  setSelectedPlan,
  setLeftSection,
}) => {
  const { userDetails } = useSelector((state: any) => state.user);

  const handleCheckout = async () => {
    const body = { customerId: userDetails?.customerId, planId: selectedPlan };
    const response = await paymentModeSelection(body);
    if (response.success) {
      window.location.href = response.redirectUrl;
    }
  };

  return (
    <>
      <h2 className="buy-ratna-modal-description-heading">
        <img width="28px" height="28px" src={ratnaImage} alt="celebration" />
        Get a Booster Package
      </h2>
      <p className="buy-ratna-modal-description-subheading">
        Want more influencers just this one time?
        <br />A booster package might help.
      </p>
      <div className="ratna-remaining-container-wrapper">
        <div className="ratna-remaining-container">
          Current Balance <img src={ratnaImage} width={20} height={20} alt="ratna" />
          <span style={{ fontWeight: 500 }}>{userDetails?.balance}</span>
        </div>
      </div>
      <div className="ratna-package-container-wrapper">
        <div className="ratna-package-container">
          {plans?.map((plan) => {
            const { backgroundColor, color, border } = getColors(plan.title);
            return (
              <div
                key={plan._id}
                className={`ratna-package-card ${selectedPlan === plan.planId && 'active-package'}`}
                onClick={() => setSelectedPlan(plan.planId)}>
                <div>
                  <h4>
                    {plan.ratnas} Ratna = ${plan.price}
                    <span
                      style={{
                        backgroundColor,
                        color,
                        borderColor: border,
                      }}
                      className="package-name">
                      {plan.title}
                    </span>
                  </h4>
                </div>
                <div>
                  <Radio
                    disableFocusRipple={false}
                    disableTouchRipple={false}
                    disableRipple={false}
                    checked={selectedPlan === plan.planId}
                    sx={{ padding: 0 }}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="modal-footer-button-container mt-0">
          <ButtonComponent variant="secondary-dark" onClick={() => setLeftSection('ratna-description')}>
            Go Back
          </ButtonComponent>
          <ButtonComponent variant="primary" onClick={handleCheckout}>
            Continue
          </ButtonComponent>
        </div>
        <div className="stripe-container one-time-ratna-boost-stripe-container">
          <LockIcon />
          <div className="stripe-text">Safe & secure checkout</div>
          <PoweredByStripe />
        </div>
      </div>
    </>
  );
};

export default OneTimeRatnaBoostSection;
